/* eslint max-classes-per-file: 0 */

import {
  PermissionsGroup as Data,
  PermissionsGroupCollection as Collection,
} from '@/typings/api/PermissionsGroup'

import { Fabric } from '@/store/createCrudModule'
import { PermissionsGroupsAdapter } from './PermissionsGroupsAdapter'


export const fabric = Fabric<Data, Collection>()

type S = PermissionGroupsState
type G = PermissionGroupsGetters
type M = PermissionGroupsMutations
type A = PermissionGroupsActions


export class PermissionGroupsState extends fabric.State {
}

export class PermissionGroupsGetters extends fabric.Getters<S> {
}

export class PermissionGroupsMutations extends fabric.Mutations<S> {
}

export class PermissionGroupsActions extends fabric.Actions<S, G, M, A> {
  protected readonly adapter = new PermissionsGroupsAdapter();

  protected readonly idName = 'id';

  public copy(options: Data) {
    return this.adapter.api.copy(options.id)
  }
}
